export default "__VITE_ASSET__FHPJO70b__"